import rawManifest from "./_manifest.json"

export type SupplementManifestEntry = {
  slug: string
  title: string
  filename: string
  pathSegments: string[]
  sourceDocId: string
  modifiedTime: string
  // h.xxxx (Google Docs heading bookmark id) → slugified production anchor.
  // Lets other pipelines deep-link into this supplement's headings without
  // re-downloading. May be absent on manifests generated before this field.
  headingAnchors?: Record<string, string>
  // Extracted from a leading `### …` heading in the source doc by
  // scripts/downloadSupplements.ts; rendered as a byline under the title.
  author?: string
}

export type SupplementsManifest = {
  generatedAt: string | null
  sourceFolderId: string
  entries: SupplementManifestEntry[]
}

// Via `unknown`: TS infers a very specific literal type for the imported
// JSON (per-entry headingAnchors with distinct key sets), which doesn't
// structurally overlap with SupplementsManifest enough for a direct cast.
export const supplementsManifest = rawManifest as unknown as SupplementsManifest
